'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import localFont from 'next/font/local';
import { trackCTAClick } from '@/lib/analytics';
import { Container } from '../ReferenceChrome';

import AuroraShaders from '@/components/ui/aurora';

const heroDisplay = localFont({
  src: [
    { path: '../../../../public/fonts/fraunces-regular.woff2', weight: '400', style: 'normal' },
    { path: '../../../../public/fonts/fraunces-600.woff2', weight: '600', style: 'normal' },
  ],
});

export function HeroRef() {
  const router = useRouter();

  return (
    <section className="relative w-full pt-14 pb-0 sm:pt-16">
      

      <Container className="relative z-10 text-center">

        {/* Headline */}
        <h1
          className={`${heroDisplay.className} mt-6 text-[2.5rem] font-normal leading-[1.15] tracking-tight text-gray-900 sm:text-5xl md:text-[3.5rem]`}
        >
          Stop monitoring rank drops.
          <br />
          <span className="text-[#129990]">Start fixing them.</span>
        </h1>

        {/* Subheadline */}
        <p className="mx-auto mt-5 max-w-xl text-base font-light leading-relaxed text-gray-500 sm:text-lg">
          RankGrip translates your Google Search Console data into a daily, prioritized checklist 
          of copy-pasteable title updates and content refreshes. No complex spreadsheets required.
        </p>

        {/* CTAs */}
        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            type="button"
            onClick={() => {
              trackCTAClick('hero', 'Start for free', '/sign-up');
              router.push('/sign-up');
            }}
            className="relative flex items-center justify-center rounded-md border border-[#129990]/50 bg-gradient-to-r from-[#129990] to-[#1EAD9F] px-8 py-3 text-sm font-medium text-white shadow-[inset_0_1px_0px_rgba(255,255,255,0.2),0_0_0_1px_rgba(18,153,144,0.3),0_2px_6px_0_rgba(18,153,144,0.25)] transition-all duration-75 hover:brightness-105 active:translate-y-[2px] active:shadow-[inset_0_1px_0px_rgba(255,255,255,0.2),0_0_0_1px_rgba(18,153,144,0.3)] cursor-pointer"
          >
            Start for free
          </button>
          <button
            type="button"
            onClick={() => {
              const el = document.getElementById('how-it-works');
              el?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="relative flex items-center justify-center rounded-md border border-gray-200 bg-white px-8 py-3 text-sm font-medium text-gray-700 shadow-sm transition-all duration-75 hover:bg-gray-50 active:translate-y-[2px] cursor-pointer"
          >
            See how it works
          </button>
        </div>

        {/* Dashboard placeholder */}
        {/*
        <div
          className="mt-10 w-full overflow-hidden rounded-t-sm border border-b-0 border-gray-200 bg-gray-50/60"
          style={{ aspectRatio: '16/7' }}
        />
        */}
      </Container>
    </section>
  );
}
